import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutAllSides: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutAllSides"><Path d="M18 21H6V19H18V21Z" fill="currentColor"/><Path d="M5 18H3V6H5V18Z" fill="currentColor"/><Path d="M21 18H19V6H21V18Z" fill="currentColor"/><Path d="M17 17H7V7H17V17Z" fill="currentColor"/><Path d="M18 5H6V3H18V5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutAllSides;
